export const SR_STARTUP = 'SR_STARTUP';
export const SR_INITIAL_AUTH_FAILED = 'SR_INITIAL_AUTH_FAILED';
export const SR_INITIAL_AUTH = 'SR_INITIAL_AUTH';
export const SR_CAN_ACCESS = 'SR_CAN_ACCESS';
